import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import assets from "../assets/imgs";
import useIsMobile from "../hooks/useIsMobile";
import config from "../config/config";
const API_URL = config.API_URL;

function Login() {
  const isMobile = useIsMobile();
  const [orgNum, setOrgNum] = useState("");
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('로그인 입력됨');

    const isOrgNumValid = (orgNum > 1000);
    if(!isOrgNumValid){
      setError("유효한 기관코드를 입력하세요.");
      return;
    }

    try {
      // OpenSearch에서 사용자 문서 조회
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include", // 세션 쿠키 전송
        body: JSON.stringify({
          incubatorCode: orgNum,
          account: account,
          pw: password,
        }),
      });
  
      if (response.ok) {
        const data = await response.json();        

        // console.log(data.message); // 로그인 성공 메시지
        // localStorage.setItem("isLoggedIn", "true"); // 로그인 상태 저장
        window.location.reload(); // 페이지 리로드 또는 리다이렉션
      } else {
        const errorData = await response.json();
        setError(errorData.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setError("오류가 발생했습니다. 콘솔을 확인하세요.");
    }
  };

  if(isMobile){
    return (
      <div style={mobileStyles.divBody}>
        <div style={mobileStyles.loginRight}>
          <form style={mobileStyles.divLoginColumn} onSubmit={handleLogin}>
            <div style={mobileStyles.divLoginColumnBody}>
              <img
                src={assets.images.img_login1}
                style={{ ...mobileStyles.imgs, width: "80%",}}
                alt="Login Illustration 1"
              />
              {/* 오류 메시지 표시 */}
              {error && (
                <p style={{ color: "red", fontSize: "14px", marginBottom: "16px" }}>
                  {error}
                </p>
              )}

              <div style={mobileStyles.divLoginInput}>
                <h3 style={mobileStyles.loginLabel}>기관코드</h3>
                <input
                  style={mobileStyles.inputLoginInput}
                  onChange={(e) => setOrgNum(e.target.value)}
                  placeholder="기관코드를 입력해주세요."
                />
              </div>
              <div style={mobileStyles.divLoginInput}>
                <h3 style={mobileStyles.loginLabel}>아이디</h3>
                <input
                  style={mobileStyles.inputLoginInput}
                  onChange={(e) => setAccount(e.target.value)}
                  placeholder="아이디를 입력해주세요."
                />
              </div>
              <div style={mobileStyles.divLoginInput}>
                <h3 style={mobileStyles.loginLabel}>비밀번호</h3>
                <input
                  style={mobileStyles.inputLoginInput}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  placeholder="비밀번호를 입력해주세요."
                />
              </div>
              <button type="submit" style={mobileStyles.btnLogin}>
                로그인
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.divBody}>
      <div style={{ ...styles.loginLeft}}>
        <img
          src={assets.images.img_login1}
          style={{ ...styles.imgs, width: "372px", position: "absolute", left: "73px", top: "85px" }}
          alt="Login Illustration 1"
        />
        <img
          src={assets.images.img_login2}
          style={{ ...styles.imgs, width: "307px", position: "absolute", left: "321px", top: "338px" }}
          alt="Login Illustration 2"
        />
        <img
          src={assets.images.img_login3}
          style={{ ...styles.imgs, width: "332px", position: "absolute", left: "106px", top: "634px" }}
          alt="Login Illustration 3"
        />
      </div>
      <div style={styles.loginRight}>
        <form style={styles.divLoginColumn} onSubmit={handleLogin}>
          <div style={styles.divLoginColumnBody}>
            {/* 오류 메시지 표시 */}
            {error && (
              <p style={{ color: "red", fontSize: "14px", marginBottom: "16px" }}>
                {error}
              </p>
            )}

            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>기관코드</h3>
              <input
                style={styles.inputLoginInput}
                onChange={(e) => setOrgNum(e.target.value)}
                placeholder="기관코드를 입력해주세요."
              />
            </div>
            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>아이디</h3>
              <input
                style={styles.inputLoginInput}
                onChange={(e) => setAccount(e.target.value)}
                placeholder="아이디를 입력해주세요."
              />
            </div>
            <div style={styles.divLoginInput}>
              <h3 style={styles.loginLabel}>비밀번호</h3>
              <input
                style={styles.inputLoginInput}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                placeholder="비밀번호를 입력해주세요."
              />
            </div>
            <button type="submit" style={styles.btnLogin}>
              로그인
            </button>
          </div>
          <div style={styles.divLoginColumnFoot}>
            <Link to={"/join"} style={styles.divLoginColumnFootP}>회원가입하기</Link>
            <Link to={"/password_find"} style={styles.divLoginColumnFootP}>비밀번호 찾기</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

const input ={
  boxSizing : "border-box"
}

const styles = {
  divBody: {
    display: "flex", width: "1440px",
    height: "100vh",
  },
  imgs: {
    width: "50%",
    height: "auto",
  },
  loginLeft: {
    width: "50%",
    backgroundColor: "#6470dd",
    height: "100%",
    position: "relative",
  },
  loginRight: {
    backgroundColor: "white",
    width: "50%",
    height: "100%",
    borderRadius: "0px 24px 24px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 4px 12.6px 0px rgba(90, 87, 93, 0.14)",
  },
  divLoginColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "44px",
    width: "418px",
  },
  divLoginColumnBody: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  divLoginInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
  },
  loginLabel: {
    color: "#232323",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
  inputLoginInput: {
    ...input,
    background: "#ffffff",
    borderRadius: "8px",
    borderStyle: "solid",
    borderColor: "#dddde2",
    borderWidth: "1px",
    padding: "12px 16px 12px 12px",
    width: "100%",
  },
  btnLogin: {
    background: "#686769",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    color: "white",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    cursor: "pointer",
  },
  divLoginColumnFoot: {
    display: "flex",
    gap: "24px",
  },
  divLoginColumnFootP: {
    color: "#515052",
    fontFamily: "Pretendard",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "21px",
  },


  container: { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" },
  form: { backgroundColor: "#fff", padding: "2rem", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
  inputGroup: { marginBottom: "1rem" },
  button: { padding: "0.5rem", backgroundColor: "#4CAF50", color: "white", border: "none", cursor: "pointer" },
};

const mobileStyles = {
  divBody: {
    display: "flex", width: "100%",
    height: "100vh",
  },
  imgs: {
    width: "50%",
    height: "auto",
  },
  loginRight: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 4px 12.6px 0px rgba(90, 87, 93, 0.14)",
  },
  divLoginColumn: {
    display: "flex",
    flexDirection: "column",
    gap: "44px",
    width: "80%",
  },
  divLoginColumnBody: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  divLoginInput: {
    ...input,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    alignItems: "flex-start",
    justifyContent: "center",
    alignSelf: "stretch",
    overflow: "hidden",
  },
  loginLabel: {
    color: "#232323",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "12px",
    lineHeight: "20px",
    fontWeight: 600,
  },
  inputLoginInput: {
    ...input,
    background: "#ffffff",
    borderRadius: "8px",
    borderStyle: "solid",
    borderColor: "#dddde2",
    borderWidth: "1px",
    padding: "12px 16px 12px 12px",
    width: "100%",
  },
  btnLogin: {
    background: "#686769",
    borderRadius: "8px",
    padding: "12px",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    color: "white",
    fontFamily: "Pretendard-SemiBold, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    cursor: "pointer",
  },
  divLoginColumnFoot: {
    display: "flex",
    gap: "24px",
  },
  divLoginColumnFootP: {
    color: "#515052",
    fontFamily: "Pretendard",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "21px",
  },
  container: { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" },
  form: { backgroundColor: "#fff", padding: "2rem", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
  inputGroup: { marginBottom: "1rem" },
  button: { padding: "0.5rem", backgroundColor: "#4CAF50", color: "white", border: "none", cursor: "pointer" },
};

export default Login;